import React from 'react';

const EditSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.78625 12.8838V10.3124L13.2148 3.88379L15.7863 6.45522L9.35769 12.8838H6.78625Z" stroke="white" stroke-width="1.3" stroke-linecap="round"/>
  <path d="M4.21387 15.4551H15.7853" stroke="white" stroke-width="1.3" stroke-linejoin="round"/>
  </svg>
  
);

export default EditSvg;
